import {
    StyledDropPointStoreAdress,
    StyledDroppointStore,
    StyledDroppointStoreTitle,
    StyledListSelector,
    StyledUlListSelector,
} from './styled';
import { Image, Button } from '~/shared/components';
import { MapMarker } from '../models/mapModel';
import { ShippingMethod } from '~/lib/data-contract/salesforce';
import { useTranslation } from '~/shared/utils/translation';

type Props = {
    selectOptionShopDelivery?: (variant: any) => void;
    optionList: MapMarker[] | null | undefined;
    selectedCarrier?: ShippingMethod;
};

export const MapList = ({ selectOptionShopDelivery, optionList, selectedCarrier }: Props) => {
    const { translate } = useTranslation();

    return (
        <StyledUlListSelector>
            {Array.isArray(optionList) &&
                optionList.map((deliveryOption) => {
                    return (
                        <StyledListSelector
                            id={deliveryOption._id}
                            data-testid="droppoint-address"
                            key={deliveryOption._id}
                        >
                            <StyledDroppointStore>
                                {selectedCarrier?.c_image && (
                                    <Image
                                        src={selectedCarrier?.c_image}
                                        alt={selectedCarrier?.name ?? ''}
                                        height={24}
                                        width={35}
                                        layout="intrinsic"
                                        objectFit="cover"
                                    />
                                )}

                                <StyledDroppointStoreTitle>
                                    {deliveryOption?.name || ''}
                                </StyledDroppointStoreTitle>

                                <StyledDropPointStoreAdress>
                                    <span>
                                        {deliveryOption?.addressLine1 || deliveryOption?.address1}
                                    </span>

                                    <span>
                                        {deliveryOption?.zip ?? deliveryOption?.postalCode},{' '}
                                        {deliveryOption?.city}
                                    </span>

                                    <span>
                                        {deliveryOption?.addressLine2 || deliveryOption?.address2}
                                    </span>
                                </StyledDropPointStoreAdress>
                            </StyledDroppointStore>

                            <Button
                                data-testid="droppoint-address-cta"
                                small
                                onClick={() => {
                                    selectOptionShopDelivery &&
                                        selectOptionShopDelivery(deliveryOption);
                                }}
                            >
                                {translate('checkout.delivery.select')}
                            </Button>
                        </StyledListSelector>
                    );
                })}
        </StyledUlListSelector>
    );
};
